import ImageBasic from "../../Common/Image/ImageBasic";
import IMG from "../../../constants/image";
import React from "react";

const CourierInfoSeller = () => (
    <div className="min-w-[353px] md:min-w-[490px] rounded-[10px] md:overflow-hidden">
        <div className="text-center text-sm font-medium bg-[#E8F2EE] py-[5px] rounded-t-[10px]">
            Vận chuyển bởi nhà bán hàng
        </div>
        <div className="flex items-center justify-between p-4 bg-[#F3F8F6] rounded-b-[10px]">
            <ImageBasic className='md:hidden' src={IMG.logo.selfDeliverySeller} alt="Delivery truck seller"/>
            <div className="text-left">
                <div className="text-xs">Bạn có thể tự vận chuyển đơn hàng này hoặc nhập thông tin</div>
                <div className="text-xs">Đơn vị vận chuyển/ Nhà xe do bên bạn hợp tác</div>
            </div>
            <ImageBasic className='hidden md:block' src={IMG.logo.selfDeliverySeller} alt="Delivery truck seller"/>
        </div>
    </div>
);
export default CourierInfoSeller;